import { useState } from "react";
import { toast } from "sonner";
import api, { errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function ForcePassword() {
  const { refreshUser, logout } = useAuth();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) { toast.error("Password must be at least 6 characters"); return; }
    if (pw !== pw2) { toast.error("Passwords do not match"); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { new_password: pw });
      toast.success("Password updated");
      await refreshUser();
    } catch (err) { toast.error(errMsg(err)); }
    setBusy(false);
  };
  const input = "mt-2 w-full border border-white/30 bg-white/5 px-4 py-3.5 text-sm text-white placeholder-white/30 focus:outline-none focus:border-white/70";
  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-[#0b0a0a] px-6">
      <div className="absolute inset-0 bg-cover bg-center grayscale" style={{ backgroundImage: "url(/login-showroom.webp)" }} />
      <div className="absolute inset-0 bg-black/85" />
      <form onSubmit={submit} className="relative z-10 w-full max-w-sm">
        <h1 className="font-heading text-3xl font-extrabold text-white">Set a new password</h1>
        <p className="mt-2 text-[11px] font-semibold uppercase tracking-[0.25em] text-white/60">Required before your first sign-in</p>
        <div className="mt-6 space-y-4">
          <input data-testid="newpw-input" type="password" required value={pw} onChange={(e) => setPw(e.target.value)} placeholder="New password (min 6 chars)" className={input} />
          <input data-testid="newpw-confirm-input" type="password" required value={pw2} onChange={(e) => setPw2(e.target.value)} placeholder="Confirm new password" className={input} />
        </div>
        <button data-testid="newpw-submit-btn" type="submit" disabled={busy}
          className="mt-6 w-full bg-[#EA2F13] px-5 py-4 text-sm font-bold uppercase tracking-[0.2em] text-white hover:bg-[#d02a10] disabled:opacity-60">
          {busy ? "Saving…" : "Save & Continue"}
        </button>
        <button type="button" onClick={logout} className="mt-4 w-full text-center text-[10px] font-bold uppercase tracking-[0.25em] text-white/40 hover:text-white/70">Sign out</button>
      </form>
    </div>
  );
}
